import React, { useState } from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import Button from '../../../Button';
import Icon from '../../../Icon';
import Caption from '../../../Caption';
import Tooltip from '../../../Tooltip';
import styles from './MainFolder.module.css';

const bindClasses = classNameBind.bind(styles);

const MainFolder = ({ children, name, addButton, isOpenLocalStorageName, onAccordionClick = () => {}, t, dataId = 'Sidebar.MainFolder' }) => {
  const [isOpen, setIsOpen] = useState(JSON.parse(localStorage.getItem(isOpenLocalStorageName) || 'true'));

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id={dataId}
    >
      <div
        className={bindClasses('header')}
        onClick={() => { onAccordionClick(!isOpen); setIsOpen(!isOpen); localStorage.setItem(isOpenLocalStorageName, !isOpen); }}
        role="button"
        tabIndex={0}
      >
        <div className={bindClasses('chevron')}>
          <Icon
            name={isOpen ? 'chevron-down' : 'chevron-right'}
            color="gray"
            size="small"
          />
        </div>
        <Caption subdued>{name}</Caption>
        <div className={bindClasses('add-button')}>
          <Tooltip content={addButton.tooltip}>
            <Button
              icon="plus"
              onClick={(e) => { e.stopPropagation(); addButton.onClick(); }}
              appearance="subdued"
              size="tiny"
              disabled={addButton.disabled}
              text={t('addFolder')}
              dataId={addButton.dataId}
            />
          </Tooltip>
        </div>
      </div>
      {
        isOpen
          ? (
            <div
              className={bindClasses('content')}
            >
              { children }
            </div>
          )
          : null
      }
    </div>
  );
};

const enhanced = withTranslation('components')(MainFolder);
enhanced.displayName = 'MainFolder';

export default enhanced;
